module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('collapse', [_c('collapse-item', {
    staticClass: "second-layer",
    attrs: {
      "title": "Повтор при ошибки или молчании"
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.generationState),
      expression: "repeatData.generationState"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.stateName + '_generateState',
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.repeatData.generationState, "url")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.repeatData, "generationState", "url")
      }
    }
  }), _vm._v("Url аудио")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.generationState),
      expression: "repeatData.generationState"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.stateName + '_generateState',
      "value": "load"
    },
    domProps: {
      "checked": _vm._q(_vm.repeatData.generationState, "load")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.repeatData, "generationState", "load")
      }
    }
  }), _vm._v("Загрузить аудио")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.generationState),
      expression: "repeatData.generationState"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.stateName + '_generateState',
      "value": "text"
    },
    domProps: {
      "checked": _vm._q(_vm.repeatData.generationState, "text")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.repeatData, "generationState", "text")
      }
    }
  }), _vm._v("Сгенерировать аудио")])])]), _vm._v(" "), _c('span', [_vm._v("Выбрано: " + _vm._s(_vm.repeatData.generationState))]), _vm._v(" "), (_vm.repeatData.generationState === 'url') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.questionAudio),
      expression: "repeatData.questionAudio"
    }],
    staticClass: "input url audioUrl",
    attrs: {
      "type": "url",
      "placeholder": "Url of audio"
    },
    domProps: {
      "value": (_vm.repeatData.questionAudio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.repeatData, "questionAudio", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio', [_c('source', {
    attrs: {
      "src": _vm.repeatData.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.repeatData.questionAudio
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.repeatData.generationState === 'text') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.questionText),
      expression: "repeatData.questionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.repeatData.questionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.repeatData, "questionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), _vm._v("\n              Сгенерировать аудио\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.currentSpeaker),
      expression: "repeatData.currentSpeaker"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.repeatData, "currentSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                  " + _vm._s(speaker.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatData.currentEmotion),
      expression: "repeatData.currentEmotion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.repeatData, "currentEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                  " + _vm._s(emotion.value) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.repeatData.currentSpeed,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.repeatData.currentSpeed = $event
      }
    }
  }), _vm._v("\n          Скорость: " + _vm._s(_vm.repeatData.currentSpeed) + "\n        ")], 1), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio', [_c('source', {
    attrs: {
      "src": _vm.repeatData.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.repeatData.questionAudio
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.repeatData.generationState === 'load') ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio', [_c('source', {
    attrs: {
      "src": _vm.repeatData.questionAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.repeatData.questionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.repeatData.questionAudio
    }
  }) : _vm._e()], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8ac640"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/depricated/GenerateRepeatAudio.vue
// module id = 430
// module chunks = 42